import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold text-accent-700 mb-2">
            <span className="w-4 h-0.5 bg-accent-500 rounded-full"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {description && <p className="mt-2 text-sm text-foreground-500 max-w-2xl">{description}</p>}
      </div>
      {action && <div className="shrink-0 hidden sm:block">{action}</div>}
    </div>
  );
}